import { useMemo } from 'react';
import styled from 'styled-components';

const SliderContainer = styled.div`
	display: grid;
	gap: 10px;
	margin: 40px 20px;
	overflow: hidden; /* Skryje položky mimo viditeľnej oblasti */
`;

const GridRow = styled.div<{ opposite?: boolean }>`
	display: flex;
	width: fit-content;
	animation: ${({ opposite }) => (opposite ? 'moveRightToLeft 60s linear infinite' : 'moveLeftToRight 60s linear infinite')};

	@keyframes moveLeftToRight {
		0% {
			transform: translateX(0%);
		}
		100% {
			transform: translateX(-50%);
		}
	}

	@keyframes moveRightToLeft {
		0% {
			transform: translateX(-50%);
		}
		100% {
			transform: translateX(0%);
		}
	}
`;

const Items = styled.div`
	display: flex;
	gap: 10px; /* medzera medzi obrázkami */
	height: 200px; /* pevná výška slideru */
	align-items: center;
`;

const Item = styled.div<{ img_width?: number }>`
	position: relative;
	border-radius: 0.8rem;
	width: 15.6rem;
	height: 200px;

	img {
		width: 100%; /* obrázok vyplní šírku boxu */
		height: 100%; /* pevná výška 200px */
		border-radius: 10px;
		display: block;
		object-fit: cover; /* oreže obrázok, aby zapadol do boxu */
	}
`;

const imageImports = {
	ABOUT_US_DISTRIBUTION: import.meta.glob('/src/assets/images/distribution/*.{jpg,jpeg,png}', {
		eager: true,
		import: 'default',
	}),
	ABOUT_US_FARM: import.meta.glob('/src/assets/images/aboutUs/farm/*.{jpg,jpeg,png}', {
		eager: true,
		import: 'default',
	}),
	ABOUT_US_PRODUCTION: import.meta.glob('/src/assets/images/aboutUs/production/*.{jpg,jpeg,png}', {
		eager: true,
		import: 'default',
	}),
	ABOUT_US_HISTORY: import.meta.glob('/src/assets/images/aboutUs/history/*.{jpg,jpeg,png}', {
		eager: true,
		import: 'default',
	}),
	ABOUT_US_PRODUCTS: import.meta.glob('/src/assets/images/aboutUs/products/*.{jpg,jpeg,png}', {
		eager: true,
		import: 'default',
	}),
};

type ImageSliderProps = {
	basePath: keyof typeof imageImports;
	width?: number;
	opposite?: boolean;
};

const ImageSlider = ({ basePath, width, opposite }: ImageSliderProps) => {
	const imageList = useMemo(() => {
		const images = imageImports[basePath];
		const imgs = Object.values(images) as string[];
		return [...imgs, ...imgs]; // duplikujeme pre plynulý nekonečný scroll
	}, [basePath]);

	return (
		<SliderContainer>
			<GridRow opposite={opposite}>
				<Items>
					{imageList.map((src, index) => (
						<Item img_width={width} key={index}>
							<img alt={`img-${index}`} src={src} />
						</Item>
					))}
				</Items>
			</GridRow>
		</SliderContainer>
	);
};

export default ImageSlider;
